import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav-bar">
      <div className="nav-left" onClick={() => navigate('/')}>
        HOME
      </div>

      <div className={`nav-right ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
        ☰
        <div className="menu-dropdown">
          <div onClick={() => navigate('/passports')}>Tickets</div>
          <div onClick={() => navigate('/schedule')}>Program</div>
          <div onClick={() => navigate('/menu')}>Menu</div>
          <div onClick={() => navigate('/toonie-taste')}>Toonie Taste</div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
